import { ITestableComponentProps } from "../../../../shared/types/testing.types";

export interface ISearchProps extends ITestableComponentProps {}

export const DefaultSearchProps: ISearchProps = {};
